
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { NotificationType } from '@alao-frontend/ui/src/types/notification'
import Loader from '~/components/Loader.vue'
import IconDone from '~/assets/icons/black-friday/icon-done.svg?inline'
import { $api } from '~/plugins/axios'
import { NotifiesOfferType } from '~/services/notifier.service'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    AlButton,
    Loader,
    IconDone,
  },
})
export default class BlackFridayEmailForm extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  readonly offerType!: NotifiesOfferType

  private isLoading = false
  private emailValue = ''

  private async submitForm () {
    if (!(await this.$validator.validate())) {
      return
    }

    try {
      this.isLoading = true
      await $api.NotifierService.subscribe({
        id: this.emailValue,
        subscribe: true,
        service: 'blackfriday25',
        offer_type: this.offerType,
      })
      this.$notify({
        title: this.$t('blackFriday.saveEmail.successNotifyTitle').toString(),
        message: this.$t('blackFriday.saveEmail.successNotifyText').toString(),
        duration: 3000,
        type: NotificationType.SUCCESS,
      })
    } finally {
      this.isLoading = false
      this.emailValue = ''
      await this.$nextTick()
      this.vErrors.clear()
    }
  }
}
